import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useT } from "../../lib/i18n";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import PublicFrame, { usePublicBranding } from "./PublicFrame";

export default function Join() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const { lang } = useT();
  const [info, setInfo] = useState(null);
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", phone: "", interest: "", marketing_consent: false, whatsapp_opt_in: false });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  usePublicBranding(info);
  useEffect(() => { api.get(`/public/c/${slug}/clinic`).then((r) => setInfo(r.data)).catch(() => setInfo(false)); }, [slug]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post(`/public/c/${slug}/lead`, { ...f, preferred_language: lang }); setDone(true); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  if (info === false) return <PublicFrame><p>Clinic not found.</p></PublicFrame>;
  return (
    <PublicFrame branding={info?.branding} embed={params.get("embed") === "1"}>
      {done ? (
        <div className="py-16 text-center space-y-3" data-testid="join-success">
          <CheckCircle2 className="h-12 w-12 text-primary mx-auto" /><h1 className="text-3xl">Thank you!</h1>
          <p className="text-muted-foreground">We've received your details and will be in touch soon.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4 max-w-lg" data-testid="join-form">
          <div><h1 className="text-3xl sm:text-4xl">Stay in touch</h1><p className="text-muted-foreground mt-2">Leave your details to receive news, offers and advice from our clinic.</p></div>
          <div className="grid grid-cols-2 gap-3">
            <Input data-testid="join-first-name" required placeholder="First name" value={f.first_name} onChange={set("first_name")} />
            <Input data-testid="join-last-name" placeholder="Last name" value={f.last_name} onChange={set("last_name")} />
          </div>
          <Input data-testid="join-email" type="email" required placeholder="Email" value={f.email} onChange={set("email")} />
          <Input data-testid="join-phone" type="tel" placeholder="Phone (optional)" value={f.phone} onChange={set("phone")} />
          <Textarea data-testid="join-interest" placeholder="What are you interested in? (optional)" value={f.interest} onChange={set("interest")} />
          <label className="flex gap-2 text-sm"><input type="checkbox" data-testid="join-marketing" checked={f.marketing_consent} onChange={set("marketing_consent")} />I agree to receive news and offers by email. I can unsubscribe at any time.</label>
          <label className="flex gap-2 text-sm"><input type="checkbox" data-testid="join-whatsapp" checked={f.whatsapp_opt_in} onChange={set("whatsapp_opt_in")} />I also agree to receive messages on WhatsApp.</label>
          <Button className="rounded-full w-full" data-testid="join-submit" disabled={busy}>Send</Button>
        </form>
      )}
    </PublicFrame>
  );
}
